export const ENV_CONFIG = {
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "",
  AUTHORITY: process.env.REACT_APP_AUTHORITY || "",
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || "",
  PRIVACY_NOTICE_URI: process.env.REACT_APP_PRIVACY_NOTICE_URI || "",
  PRIVACY_NOTICE_DESC: process.env.REACT_APP_PRIVACY_NOTICE_DESC || "",
  CACHE_LOCATION: process.env.REACT_APP_CACHE_LOCATION || "sessionStorage",
  IS_DEV_ENV: process.env.NODE_ENV === "development",
  BUILD_ID: process.env.REACT_APP_BUILD_ID,
  API_URL: process.env.REACT_APP_API_URI || "/",
  GDX_API_URL: process.env.REACT_APP_GDX_API_URL,
  ENG_API_URL: process.env.REACT_APP_ENG_API_URL,
  GDX_FUNCAPP_API_URL: process.env.REACT_APP_GDX_FUNCAPP_API_URL,
  CHATBOT_FUNCAPP_URL: process.env.REACT_APP_CHATBOT_FUNCAPP_URL,
  SEARCH_API_URL: process.env.REACT_APP_SEARCH_API_URL,
  IP_GEOLOCATION_SERVICE_ENDPOINT:
    process.env.REACT_APP_IRP_GEOLOCATION_ENDPOINT,
  IP_GEOLOCATION_API_KEY: process.env.REACT_APP_IRP_GEOLOCATION_API_KEY
};
